import Filters from "components/common/Filters";
import CommonTitleBar from "components/common/CommonTitleBar";
import DeleteConfirmationModal from "components/common/ConfirmationDialog";
import NoDataFound from "components/common/NoDataFound";
import Spinners from "components/common/Spinners";
import {
  formatDate,
  formatPlanType,
  getMinMaxDate,
  handleStopPropagation,
} from "components/common/Utils";
import { couponsStatus } from "components/constants/StatusKeys";
import { Ellipsis, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Col, Container, Dropdown, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { showAlert } from "store/reducers/alertReducer";
import Paginations from "components/common/Paginations";
import { getPlans } from "store/actions/subscriptionPlansSlice";

const Plans = () => {
  const { t } = useTranslation();

  document.title = t("Plans | Work space");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    loading,
    isLoading,
    plans,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Plans);

  const [keyword, setKeyword] = useState("");
  const [dates, setDates] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false); // DELETE MODAL
  const [show, setShow] = useState(false);
  const [newCode, setNewCode] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({
    status: 1,
    discountType: "",
    discountValue: null,
    totalUsedMin: null,
    totalUsedMax: null,
    totalUsedLimitMin: null,
    totalUsedLimitMax: null,
    totalRedeemedMin: null,
    totalRedeemedMax: null,
  });
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [showDropdown, setShowDropdown] = useState(false);
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  useEffect(() => {
    getAllData(currentPage);
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const isReset = actionType === "RESET";
    const payload = {
      perPage,
      pageNo: page || pageNumber,
      status: selectedFilters.status,
      orderBy: selectedFilters.orderBy,
      keyword: ["RESET", "RESET_KEYWORD"].includes(actionType)
        ? ""
        : keyword || "",
    };
    dispatch(getPlans(payload));
  };

  return (
    <React.Fragment>
      <div className="page-content common_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Plans & Pricing")}
            isCreateBtn={false}
            createBtnText={t("Add New")}
            onCreateBtnClick={() => navigate(`/management/plans/add-new-plan`)}
          />
          <div className="common_wrapper">
            <Row>
              <Col lg={12}>
                {loading ? (
                  <Spinners />
                ) : plans.length === 0 ? (
                  <NoDataFound />
                ) : (
                  <div
                    className="common_table_style mt_20"
                    style={{ minHeight: showDropdown ? 260 : "unset" }}
                  >
                    <Table>
                      <thead className="t_head">
                        <tr>
                          <th>{t("Plan Name")}</th>
                          <th>{t("Billing Cycle")}</th>
                          <th>{t("Trial Duration")}</th>
                          <th>{t("Discount")}</th>
                          <th>{t("Features")}</th>
                          <th>{t("Last Updated")}</th>
                          <th>{t("Actions")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {plans?.map((item, index) => (
                          <tr key={item?._id}>
                            <td>{item?.name}</td>
                            <td>{formatPlanType(item?.billingCycle)}</td>
                            <td>
                              {item?.trialPeriodDays} {t("Days")}
                            </td>
                            <td>{item?.discountInPercentage}%</td>
                            <td
                              className="tbl_dtl_m0"
                              style={{ minWidth: "260px" }}
                            >
                              <div
                                style={{ maxHeight: "130px" ,overflowY:"scroll" }}
                              >
                                {" "}
                                {item.features.map((feature, index) => (
                                  <p>- {feature?.title}</p>
                                ))}
                              </div>
                            </td>

                            <td>
                              <p className="w_fit_content">
                                {formatDate(item?.updatedAt || "-")}
                              </p>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-3">
                                <Dropdown
                                  className="custom_dropdown list_action_dropdown table_action_btn"
                                  drop={"down"}
                                  onToggle={(isOpen) => setShowDropdown(isOpen)}
                                >
                                  <Dropdown.Toggle>
                                    <Ellipsis className="text_black" />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu align="end">
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() => {
                                        navigate(
                                          `/management/plans/edit-plan?id=${item?._id}`
                                        );
                                      }}
                                    >
                                      {t("Edit")}
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Plans;
